import { EBlockchainType, Chain } from '@ankr.com/chains-list';

export const extractCustomizedChains = (chains: Chain[]) => {
  return chains.reduce<[Chain[], Chain[]]>(
    (acc, chain) => {
      if (chain.type === EBlockchainType.Customized) {
        acc[1].push(chain);
      } else {
        acc[0].push(chain);
      }

      return acc;
    },
    [[], []],
  );
};
